import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";

  export default {
    components: {
      VueBootstrapTypeahead
    },
    data() {
      return {
        ShowLoader: false,
        Saving: false,
        file:'',
        SavingFile:false,
        submitted: false,
        ExemptPsv:true,
        SearchKey: "",
        Branches:{},
        NewTrailer: {
          vrm: "",
          make: "",
          model: "",
          class: "Trailer",
          adhoc:false,
          branch_id: 0,
          trailer_type: "Curtain Sider",
          capacity: "",
          max_load_weight: "",
          unladen_weight: "",
          last_pmi_date:"",
          next_pmi_due:"",
          year:"",
          exempt_psv:true,
          tyre_size:"",
          number_of_axels:"",
          psv_date:"",
          chassis_no:""
        },
        select_branch:true,
        FleetSubscriptionModules:[]     
      };
    },
    validations: {
      NewTrailer: {
        vrm: { required }
      },
    },
    mounted() {
      //check account permission
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
        );
        this.FleetSubscription = JSON.parse(
          localStorage.getItem("FleetSubscription")
        );
        var FleetSubscriptionModules = JSON.parse(
          this.FleetSubscription.fleet_modules
        );
        this.FleetSubscriptionModules = FleetSubscriptionModules;
      if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Trailers || !AccountPermissions.Trailers.enable || !AccountPermissions.Trailers.add) ){
        this.$router.push('/');
      }

      this.GetBranches();
    },
    computed : {
      years () {
        const year = new Date().getFullYear()
        return Array.from({length: year - 1969}, (value, index) => 1970 + index)
      }
    },
    methods: {
      GetBranches(){
        var obj = { token: localStorage.getItem("token"), select_branch: true};
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Branches = Response.data.records;
            if(this.FleetSubscriptionModules["Hierarchy System"] && this.Branches.length == 1){
              this.NewTrailer.branch_id = this.Branches[0].id;
              this.select_branch = false;
            }
          }
        });
      },
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      SaveTrailerData() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        if(this.NewTrailer.vrm == ''){
          this.$swal.fire('Enter Trailer Reg ID', '', 'error').then(() => {});
        }else{
          this.Saving = true;
          if (this.$refs.file && this.$refs.file.files[0]) {
            let formData = new FormData();
            formData.append('token', localStorage.getItem('token'));
            formData.append('storage_type', 'CFT');
            formData.append('file', this.file);
            formData.append('reg_id', this.NewTrailer.vrm);
            Axios.post(Endpoints.File.Upload, formData).then((Response) => {
              this.SavingFile = false;
              if (Response?.data?.success == true) {
                  this.NewTrailer.image = Response.data.file;
                  this.file = '';
                  this.CreateTrailer();
              } else {
                this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
              }
            });
          }else{
            this.CreateTrailer();
          }

        }
        
      },	
      CreateTrailer() {
        Axios.post(Endpoints.Trailer.Create, {
          token: localStorage.getItem("token"),
          ...this.NewTrailer,
        }).then((Response) => {
          this.Saving = false;
          if (Response?.data?.success) {
            this.$swal
              .fire("Trailer Added Successfully", "", "success")
              .then(() => {
                this.$router.push("/trailers-list");
              });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response?.data?.message || "Something went wrong",
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      SetTrailerType(type){
        this.NewTrailer.trailer_type=type;
      },
      SetExemptPSV(type){
        this.ExemptPsv = type;
        this.NewTrailer.exempt_psv=type;
        if(type){
          this.NewTrailer.psv_date='';
        }
      },
      SetPSVDate(){
        this.ExemptPsv = false;
        this.NewTrailer.exempt_psv= false;
      },
    },
  };